import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UrlMaker } from 'src/app/commons/url-maker';
import { environment } from 'src/environments/environment';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { InstanceVersionInfo } from 'src/app/model/instance';
import { CustomerService } from './customer.service';
@Injectable({
    providedIn: 'root',
})
export class ProductService {
    storeApiUrl: string;
    resellerCode: string;
    productRelease: string = '';
    instanceVersionInfo: InstanceVersionInfo;

    constructor(private http: HttpClient) {
        this.storeApiUrl = environment.settings.storeApiUrl;
        this.productRelease = '';
    }

    public setResellerCode(resellerCode: string) {
        this.resellerCode = resellerCode;
    }
    public async setProductRelease(
        productID: string,
        subscriptionMode: string,
        countrySelected: string,
        susbcriptionKey: string,
        industryModuleCode: string,
        isTester: string,
        instanceKey: string
    ) {
        if (this.productRelease.length == 0) {
            let result: InstanceVersionInfo = await this.getRelease(
                productID,
                subscriptionMode,
                countrySelected,
                susbcriptionKey,
                industryModuleCode,
                isTester,
                instanceKey
            );
            if (!result) {
                this.productRelease = 'all';
                this.instanceVersionInfo = new InstanceVersionInfo();
            } else {
                this.instanceVersionInfo = result as InstanceVersionInfo;
                this.productRelease = result.Version && result.Version.length > 0 ? result.Version : 'all';
            }
        }
    }

    private async getRelease(
        productID: string,
        subMode: string,
        selectedISOCountry: string,
        subscriptionKey: string,
        industryModuleCode: string,
        isTester: string,
        instanceKey: string
    ): Promise<InstanceVersionInfo> {
        const url = new UrlMaker().appendBaseUrl(this.storeApiUrl).appendSegment('getProductRelease').toString();

        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        const jobj = {
            productID: productID,
            resellerCode: this.resellerCode,
            subMode: subMode,
            selectedISOCountry: selectedISOCountry,
            subscriptionKey: subscriptionKey,
            industryModuleCode: industryModuleCode,
            isTester: isTester,
            instanceKey: instanceKey,
        };

        const bodyString = JSON.stringify(jobj);
        return this.http
            .post<InstanceVersionInfo>(url.toString(), bodyString, { headers })
            .pipe(catchError((error: HttpErrorResponse) => throwError(error || 'Server error in getProductRelease')))
            .toPromise();
    }

    public getProductImage(productKey: string): string | null {
      switch(productKey){
        case 'MAGOWEB':
          return 'assets/MW_b.png'
        case 'MAGOCLD':
          return 'assets/MAGOCLOUD-logo.png'
        case 'MAGO4':
          return 'assets/MAGO4-bLogo.png'
        case 'MAGO.NET':
          return 'assets/MagoNet-logo.png'
        default:
          return null;
      }
    }
}
